module.exports = __webpack_public_path__ + "img/Öhm.e15c83bf.jpg";